import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "External Tenants", -1);
var _hoisted_2 = {
  "class": "flex items-center justify-start mb-6"
};
var _hoisted_3 = {
  "class": "bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_4 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_5 = {
  "class": "text-left font-bold"
};
var _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "User Id", -1);
var _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name", -1);
var _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "IS Manager", -1);
var _hoisted_9 = ["onClick"];
var _hoisted_10 = {
  "class": "border-t"
};
var _hoisted_11 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_12 = {
  "class": "border-t"
};
var _hoisted_13 = {
  "class": "flex items-center px-6 py-4 focus:text-indigo-500"
};
var _hoisted_14 = {
  "class": "border-t"
};
var _hoisted_15 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_16 = {
  "class": "border-t"
};
var _hoisted_17 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_18 = {
  "class": "border-t"
};
var _hoisted_19 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_20 = {
  key: 0
};
var _hoisted_21 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4 border-t",
  colspan: "4"
}, "No external tenant found.", -1);
var _hoisted_22 = [_hoisted_21];
var _hoisted_23 = {
  "class": "text-center capitalize"
};
var _hoisted_24 = {
  "class": "w-full whitespace-nowrap"
};
var _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", {
  "class": "text-left font-bold"
}, [/*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Name"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Status"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Contacts"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Follow Ups"), /*#__PURE__*/_createElementVNode("th", {
  "class": "pb-4 pt-6 px-6"
}, "Alias Account")])], -1);
var _hoisted_26 = {
  "class": "border-t"
};
var _hoisted_27 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_28 = {
  "class": "border-t"
};
var _hoisted_29 = {
  "class": "flex items-center px-6 py-4 focus:text-indigo-500"
};
var _hoisted_30 = {
  "class": "border-t"
};
var _hoisted_31 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_32 = {
  "class": "border-t"
};
var _hoisted_33 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_34 = {
  "class": "border-t"
};
var _hoisted_35 = {
  "class": "flex items-center px-6 py-4",
  tabindex: "-1"
};
var _hoisted_36 = {
  key: 0
};
var _hoisted_37 = /*#__PURE__*/_createElementVNode("td", {
  "class": "px-6 py-4 border-t",
  colspan: "4"
}, "No campaigns in tenant.", -1);
var _hoisted_38 = [_hoisted_37];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_icon = _resolveComponent("icon");
  var _component_pagination = _resolveComponent("pagination");
  var _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_Head, {
    title: "Organizations"
  }), _hoisted_1, _createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
    type: "text",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.form.search = $event;
    }),
    "class": "border w-80 p-6",
    style: {
      "height": "25px"
    }
  }, null, 512), [[_vModelText, $data.form.search]]), _createElementVNode("button", {
    "class": "ml-3 text-white focus:text-indigo-500 text-sm bg-indigo-800 px-6 rounded-md",
    type: "button",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.reset && $options.reset.apply($options, arguments);
    })
  }, "Reset")]), _createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_createElementVNode("thead", null, [_createElementVNode("tr", _hoisted_5, [_hoisted_6, _hoisted_7, _hoisted_8, _createElementVNode("th", {
    "class": "pb-4 pt-6 px-6 cursor-pointer",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.changeOrder('created_at');
    })
  }, "joined at " + _toDisplayString($data.form.order_by == 'created_at' ? '(' + $data.form.order + ')' : ''), 1), _createElementVNode("th", {
    "class": "pb-4 pt-6 px-6 cursor-pointer",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.changeOrder('activity_status');
    })
  }, "Activity Status " + _toDisplayString($data.form.order_by == 'activity_status' ? '(' + $data.form.order + ')' : ''), 1)])]), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.externalTenantList.data, function (organization) {
    return _openBlock(), _createElementBlock("tr", {
      key: organization.id,
      "class": "hover:bg-gray-100 focus-within:bg-gray-100",
      onClick: function onClick($event) {
        return $options.getCampaignData(organization.id, organization.name);
      }
    }, [_createElementVNode("td", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(organization.userId), 1)]), _createElementVNode("td", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createTextVNode(_toDisplayString(organization.name) + " ", 1), organization.deleted_at ? (_openBlock(), _createBlock(_component_icon, {
      key: 0,
      name: "trash",
      "class": "flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"
    })) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(organization.isManager), 1)]), _createElementVNode("td", _hoisted_16, [_createElementVNode("div", _hoisted_17, _toDisplayString(new Date(organization.createdAt).toLocaleString()), 1)]), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(organization.activity_status), 1)])], 8, _hoisted_9);
  }), 128)), $props.externalTenantList.data.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_20, _hoisted_22)) : _createCommentVNode("", true)])])]), _createVNode(_component_pagination, {
    "class": "mt-6",
    links: $props.externalTenantList.links
  }, null, 8, ["links"])]), _createVNode(_component_el_dialog, {
    modelValue: $data.showCampaignList,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.showCampaignList = $event;
    }),
    top: "5vh",
    center: ""
  }, {
    header: _withCtx(function () {
      return [_createElementVNode("h4", _hoisted_23, "Campaign List (" + _toDisplayString($data.tenant_id) + ")", 1)];
    }),
    "default": _withCtx(function () {
      return [_createElementVNode("table", _hoisted_24, [_hoisted_25, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.campaignList, function (campaign) {
        return _openBlock(), _createElementBlock("tr", {
          key: $data.campaignList.id
        }, [_createElementVNode("td", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString(campaign.name), 1)]), _createElementVNode("td", _hoisted_28, [_createElementVNode("div", _hoisted_29, _toDisplayString(campaign.status), 1)]), _createElementVNode("td", _hoisted_30, [_createElementVNode("div", _hoisted_31, _toDisplayString(campaign.contacts), 1)]), _createElementVNode("td", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(campaign.follow_ups), 1)]), _createElementVNode("td", _hoisted_34, [_createElementVNode("div", _hoisted_35, _toDisplayString(campaign.alias_account), 1)])]);
      }), 128)), $props.externalTenantList.data.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_36, _hoisted_38)) : _createCommentVNode("", true)])])];
    }),
    _: 1
  }, 8, ["modelValue"])], 64);
}